module.exports = __webpack_public_path__ + "media/img/features/dark-theme-thumb-9f1da9ae5c8c81fe250cad798668f857.png";